import Plan from './models/plan-interface';
import httpClient from '../../http';

const getAllPlans = async (): Promise<Plan[]> => {
  const plans = (await httpClient.get('/plans', { params: { status: 'active' } })).data;
  return plans;
};

export { getAllPlans };
